function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.521 11.187a6.95 6.95 0 0 0 1.432-4.219C13.953 3.122 10.828 0 6.977 0S0 3.122 0 6.968c0 3.847 3.126 6.969 6.977 6.969a6.97 6.97 0 0 0 4.223-1.43l3.219 3.214a.935.935 0 0 0 .65.279.903.903 0 0 0 .652-.279.92.92 0 0 0 0-1.32l-3.2-3.214zm-5.544.892a5.122 5.122 0 0 1-5.117-5.11 5.122 5.122 0 0 1 5.117-5.11 5.11 5.11 0 0 1 5.116 5.11c0 2.824-2.307 5.11-5.116 5.11z",
  fill: "currentColor"
});

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgSearch;